/*
 * @author BSG <dev@bsgroup.eu>
 * @copyright Better Software Group S.A.
 * @version: 1.0
 */
import React, { createContext, useContext } from "react";

import { BasePlayerConfig, PlayerControllerType } from "../types";

const defaultConfig: BasePlayerConfig = {
  playerType: PlayerControllerType.ShakaPlayer,
};

const PlayerConfigContext = createContext<BasePlayerConfig>(defaultConfig);

export const PlayerConfigProvider: React.FC<{
  config: BasePlayerConfig;
  children: React.ReactNode;
}> = ({ config, children }) => {
  return (
    <PlayerConfigContext.Provider value={config}>
      {children}
    </PlayerConfigContext.Provider>
  );
};

export const usePlayerConfig = (): BasePlayerConfig => {
  return useContext(PlayerConfigContext);
};
